import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { moderateClubRating, type ModerateClubRatingRequest } from './request';

export const useModerateClubRating = () => {
  const queryClient = useQueryClient();

  return useMutation<AxiosResponse, Error, ModerateClubRatingRequest>({
    // функция мутации
    mutationFn: (params: ModerateClubRatingRequest) =>
      moderateClubRating({ params }),

    // коллбек после успеха
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ClubRatings'] });
    }
  });
};
